import { render, staticRenderFns } from "./educat.vue?vue&type=template&id=6ff944e4&scoped=true&"
import script from "./educat.vue?vue&type=script&lang=js&"
export * from "./educat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff944e4",
  null
  
)

export default component.exports